@if (!pdfLoaded && !pdfError) {
  <div class="pdf-loader-container">
    <app-loader loadingText="Loading file..."></app-loader>
  </div>
}

@if (pdfError) {
  <div class="pdf-loader-container">
    <img
      ngSrc="./assets/graphic-error.svg"
      alt=""
      height="142"
      width="212" />
    <h2 class="mt-5">Oh no!</h2>
    <p class="container-380 mx-auto text-center">
      <strong>{{ errorMessage }}</strong>
    </p>
    <button
      class="btn btn-primary mt-3"
      (click)="retryLoad()">
      <i class="iconoir-refresh-double me-2"></i>
      Retry
    </button>
  </div>
}

@if (!pdfError && showPdfViewer) {
  <ngx-extended-pdf-viewer
    #pdfViewerRef
    [src]="url()"
    [height]="'80vh'"
    [textLayer]="true"
    [customToolbar]="customToolbar"
    [zoom]="zoom"
    [mobileFriendlyZoom]="'100%'"
    (pdfLoaded)="onPdfLoaded()"
    (pdfLoadingFailed)="onPdfLoadError($event)"
    (error)="onPdfLoadError($event)">
    <ng-template #customToolbar>
      <div class="row gy-2 align-items-center justify-content-center">
        <!-- pagination options -->
        <div class="col-auto">
          <div class="row align-items-center flex-nowrap">
            <div class="col-auto">
              <label
                class="visually-hidden"
                for="pageNumber"
                >Page</label
              >
              <input
                type="number"
                id="pageNumber"
                class="form-control form-control-sm"
                title="Page"
                min="1"
                [value]="currentPage"
                (change)="onPageChange($event)"
                data-l10n-id="pdfjs-page-input" />
            </div>
            <div class="col-auto ps-0">
              <span id="numPages"></span>
            </div>
            <div class="col-auto">
              <button
                id="previous"
                class="btn-action"
                title="Previous Page"
                data-l10n-id="pdfjs-previous-button"
                (click)="previousPage()">
                <i class="iconoir-nav-arrow-left"></i>
              </button>
            </div>
            <div class="col-auto">
              <button
                id="next"
                class="btn-action"
                title="Next Page"
                data-l10n-id="pdfjs-next-button"
                (click)="nextPage()">
                <i class="iconoir-nav-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
        <!-- Zoom options -->
        <div class="col-auto">
          <div id="scaleSelectContainer">
            <label
              class="visually-hidden"
              for="scaleSelect"
              >Zoom</label
            >
            <select
              id="scaleSelect"
              title="Zoom"
              class="form-select form-select-sm"
              data-l10n-id="pdfjs-zoom-select"
              [(ngModel)]="zoom"
              (change)="onSelectZoomChange($event)">
              <option value="auto">Automatic Zoom</option>
              <option value="page-actual">Actual Size</option>
              <option value="page-fit">Page Fit</option>
              <option value="page-width">Page Width</option>
              <option value="0.5">50%</option>
              <option value="0.75">75%</option>
              <option value="1">100%</option>
              <option value="1.25">125%</option>
              <option value="1.5">150%</option>
              <option value="2">200%</option>
              <option value="3">300%</option>
              <option value="4">400%</option>
            </select>
          </div>
        </div>
        <!-- rotate buttons -->
        <div class="col-auto">
          <div class="row align-items-center">
            <div class="col-auto">
              <button
                id="pageRotateCcw"
                class="btn-action"
                title="Rotate Counterclockwise"
                data-l10n-id="pdfjs-page-rotate-ccw-button"
                (click)="rotateCounterClockwise()">
                <i class="pays-svg-icon ic-rotate-left"></i>
              </button>
            </div>
            <div class="col-auto">
              <button
                id="pageRotateCw"
                class="btn-action"
                title="Rotate Clockwise"
                data-l10n-id="pdfjs-page-rotate-cw-button"
                (click)="rotateClockwise()">
                <i class="pays-svg-icon ic-rotate-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </ngx-extended-pdf-viewer>
}
